// A saved, server-owned Scout is stronger evidence than an onboarding UI status.
// Delayed completion events must never send an existing account back to signup.
export function hasSavedScout(profile) {
  const scoutId = profile?.primaryScoutId;
  return Boolean(scoutId && profile?.jobScouts?.[scoutId]?.scoutId === scoutId);
}

export function needsOnboarding(profile) {
  return (
    !hasSavedScout(profile) &&
    !['saving', 'queued', 'processing', 'retrying'].includes(profile?.onboardingCompletionStatus)
  );
}

export function applyPendingOnboarding(profile, updates) {
  return hasSavedScout(profile) ? profile : { ...profile, ...updates };
}

// Basic inventory browsing does not require a completed Scout setup.
export function isBasicJobSearchPath(pathname) {
  return pathname === '/opportunities' || /^\/job\/[^/]+\/?$/.test(pathname);
}
